import { Button, Form } from 'react-bootstrap';

function HomeScreen (): JSX.Element {
    return (
        <></>
    );
}

export default HomeScreen;
